import { render, staticRenderFns } from "./UnidadeList.vue?vue&type=template&id=6818135a&scoped=true"
import script from "./UnidadeList.vue?vue&type=script&lang=js"
export * from "./UnidadeList.vue?vue&type=script&lang=js"
import style0 from "./UnidadeList.vue?vue&type=style&index=0&id=6818135a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6818135a",
  null
  
)

export default component.exports